import { isNative } from 'src/utils/platform';
import { env } from 'src/config/env';

export const isWebWithRcSdk = () =>
  !isNative() && !!env.rcWebApiKey;
